import api, { ApiResponse } from './api'
import type { MerchantPaymentMethod, MerchantPaymentMethodListResponse, PaymentMethod } from '../types'

export function listPaymentMethods(): Promise<ApiResponse<MerchantPaymentMethodListResponse>> {
  return api.get('/v1/merchant/payment-methods')
}

export function updatePaymentMethodStatus(
  paymentMethod: PaymentMethod,
  enabled: boolean,
  bindingId: string
): Promise<ApiResponse<MerchantPaymentMethod>> {
  return api.patch(`/v1/merchant/payment-methods/${paymentMethod}/status`, { enabled, bindingId })
}

export function updatePaymentMethodFeeSharing(
  paymentMethod: PaymentMethod,
  data: {
    customerFeeRate: string
    customerPerTransactionFee: string
    checkoutDisplayText?: string
    bindingId: string
  }
): Promise<ApiResponse<MerchantPaymentMethod>> {
  return api.patch(`/v1/merchant/payment-methods/${paymentMethod}/fee-sharing`, data)
}
